import mixpanel from "mixpanel-browser"
import { PAYMENT_EVENTS } from "."

export interface StartBasicPlanProps {
  features: string[] | null
  email: string
  subtotal: number
  currency: string
  registrationDate: string
  lastLifeUsage: string | null
  daysBetween: number
}

export function startBasicPlan(props: StartBasicPlanProps) {
  mixpanel.track(PAYMENT_EVENTS.START_BASIC_PLAN, props)
}
